import axios from "axios";

const baseURL = import.meta.env.VITE_BACKEND_STA_API_URL;

export const api = axios.create({
  baseURL: baseURL,
  timeout: 20000,
});
